import { SCALE } from '../../constants';
import { Box } from '@material-ui/core';
import React from 'react';

const PageFooter = ({ title, page, totalPages }) => {
  return (
    <Box
      textAlign="center"
      mt="auto"
      fontSize={10 * SCALE}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      borderTop="1px solid #ccc"
      paddingTop={`${20 * SCALE}px`}
      paddingBottom={`${20 * SCALE}px`}
      fontFamily="OpenSans"
      fontWeight="400"
    >
      <div>{title}</div>
      <div>
        {' '}
        Page {page} of {totalPages}
      </div>
    </Box>
  );
};
export default PageFooter;
